<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!componentSelected) {
        <h1 class="title">Crear componente</h1>
      }
    </div>
    <div class="title-color">
      @if (componentSelected) {
        <h1 class="title">Editar componente</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="componentForm" (ngSubmit)="saveComponent()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (componentForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (componentForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
              @if (componentForm.get('description')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Riesgo</mat-label>
              <input
                type="text"
                matInput
                placeholder="Riesgo"
                formControlName="risk"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (componentForm.get('risk')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (componentForm.get('risk')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Objetivo</mat-label>
              <textarea
                matInput
                placeholder="Objetivo"
                formControlName="objective"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
              @if (componentForm.get('objective')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Resultado</mat-label>
              <textarea
                matInput
                placeholder="Resultado"
                formControlName="result"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
              @if (componentForm.get('result')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="lineSelected"
                [initialValue]="getLineValue()"
                placeholder="Línea"
                label="Línea"
                noResults="Sin resultados"
                (onSelectOption)="onLineSelected($event)"
              >
              </app-search-select>
            </div>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!componentForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
